import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../../query/types';

const consumerStoreItemKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'items'] as const;

  return createQueryKey({
    all: key,
    id: (itemId: QueryKeyParam) =>
      createQueryKey({
        all: [...key, itemId] as const,
        detail: [...key, itemId, 'detail'] as const,
        inventory: [...key, itemId, 'inventory'] as const,
      }),
  });
};

export { consumerStoreItemKeys };
